import ContentReadOn from './ContentReadOn'

export default ContentReadOn
